export const testInfo = {
    time: {
        testDate: '04/04/2018',
        DaysRemaining: '24 Days',
        TotalVideoHours: '65',
        ExpectedScore: '500/528'
    },
    statistic: {
        DdlSet: '24',
        DdlMissed: '24/4',
        RecommendationsGiven: '65',
        RecommendationsFollowed: '34/65',
    },
    sessions: {
        sessionsPerWeek: '7',
        avgSessionDuration: '2 hours',
        avgChapCompletedPerSession: '2',
        RecommendationsFollowed: '34/65'
    }
};


// WEBPACK FOOTER //
// ./src/data/testInfo.js